module.exports = __webpack_public_path__ + "static/media/hero-message.3ba9a5ff.png";